mutation Inertia_CreateDocument($orderId: ID!, $fileId: ID!, $name: String) {
  createDocument(input: { orderId: $orderId, fileId: $fileId, name: $name }) {
    document {
      id
      name
    }
    errors
  }
}